module.exports = __webpack_public_path__ + "static/media/icon_nav_reports.48832a76.svg";